import { helper } from '@ember/component/helper';

export default helper(function isDataPlaneAccountError([
  failedOperationErrorMessage,
]) {
  return failedOperationErrorMessage?.includes('failed to reserve account');
});
